import { useContext } from 'react';
import { ControllerContext } from 'components/Controller/Controller';
import GrayButton from 'ui/GrayButton/GrayButton';
import Text from 'ui/Text/Text';
import Title from 'ui/Title/Title';
import { screens } from '../constants';
import './Roadmap.scss';
import './RoadmapAnim.scss';

const Roadmap: React.FC = () => {
  const { active, dispatchInnerActive } = useContext(ControllerContext);

  const listData = [
    {
      q: 'Q1',
      description:
        'Foundation & Tech Build \nMarket Expansion \nInnovation & Collaboration',
      className: '--quarter-1',
      onClick: () => dispatchInnerActive(active, screens.ROADMAP__INNER_1),
    },
    {
      q: 'Q2',
      description:
        'Development & Testing \nMarket Penetration \nScaling & Diversification',
      className: '--quarter-2',
      onClick: () => dispatchInnerActive(active, screens.ROADMAP__INNER_2),
    },
    {
      q: 'Q3',
      description:
        'Technology Foundation \nMarket Growth \nEcosystem Expansion',
      className: '--quarter-3',
      onClick: () => dispatchInnerActive(active, screens.ROADMAP__INNER_3),
    },
  ];

  return (
    <div className="roadmap section" id="roadmap">
      <div className="roadmap__map">
        <ul className="roadmap__list">
          {listData.map((item) => (
            <li
              className={'roadmap__list-item ' + item.className}
              key={item.q}
              onClick={item.onClick}
            >
              <div>
                <div className="roadmap-transition">
                  <h3 className="roadmap__list-title">{item.q}</h3>
                  <p className="roadmap__list-text">
                    {item.description.split('\n').map((word, id, arr) => (
                      <>
                        {word}
                        {arr.length !== id && <br />}
                      </>
                    ))}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className="container roadmap__container">
        <div className="roadmap__content">
          <Title className="roadmap__title">Roadmap</Title>
          <Text className="roadmap__text">
            Charting Our Course: Ambitious roadmap, guiding our blockchain
            startup's evolution from inception, through innovation, to industry
            leadership
          </Text>
          {/* <GrayButton className="start-btn roadmap__btn">
            <div className="start-btn__img">
              <img src={require('images/sphere-journey.png')} alt="sphere" />
            </div>
            <span className="start-btn__text">Start Now</span>
          </GrayButton> */}
        </div>
      </div>
    </div>
  );
};

export default Roadmap;
